import { ApolloClient, InMemoryCache } from '@apollo/client';
import environments from '../environments';

const client = new ApolloClient({
  uri: `${environments.API_BASE_URI}/graphql`,
  cache: new InMemoryCache({ resultCaching: false }),
});

export default client;
